import * as React       from 'react';
import {
    TranslationFunction,
    MessageDeliveryStatuses
}                       from '../../types';
import icons            from '../../icons';
import Expire           from '../../components/Expire';
import LoadingAnimation from '../../components/LoadingAnimation';

interface MessageStatusTextProps {
    translate: TranslationFunction;
    message: string;
    delay?: number;
}

interface MessageStatusIconProps {
    icon: JSX.Element;
    delay?: number;
}

export const StatusMessages = {
    [MessageDeliveryStatuses.NEW]: { message: 'sending'},
    [MessageDeliveryStatuses.IN_PROGRESS]: { message: 'sending' },
    [MessageDeliveryStatuses.FAILED]: { message: 'sending_failed_desktop' },
    [MessageDeliveryStatuses.ERROR]: { message: 'sending_failed_desktop' }, // fallback message for errors
    [MessageDeliveryStatuses.SUCCESS]: { message: 'sent_successfully', delay: 5000 },
    [MessageDeliveryStatuses.RETRY]: { message: 'retry_sending_message' },
    [MessageDeliveryStatuses.PROFANITY]: { message: 'profanity_content' },
    [MessageDeliveryStatuses.DNC]: { message: 'dnc' }
};

export const StatusIcons = {
    [MessageDeliveryStatuses.NEW]: { icon: <LoadingAnimation className="statusIcon--loading" /> },
    [MessageDeliveryStatuses.IN_PROGRESS]: { icon: <LoadingAnimation className="statusIcon--loading" /> },
    [MessageDeliveryStatuses.FAILED]: { icon: icons.alertCircle },
    [MessageDeliveryStatuses.ERROR]: { icon: icons.alertCircle },
    [MessageDeliveryStatuses.SUCCESS]: { icon: icons.successCheck, delay: 5000 }
};

export const MessageStatusText: React.StatelessComponent<MessageStatusTextProps> = ({ translate, message, delay }) => (
    <Expire delay={delay}>
        <div className="messagesFeed__statusMessage">
            <div className="messagesFeed__statusMessage__message">{translate(message)}</div>
        </div>
    </Expire>
);

export const MessageStatusIcon: React.StatelessComponent<MessageStatusIconProps> = ({ delay, icon }) => (
    <Expire delay={delay}>
        <div className="messagesFeed__statusIcon">
            {icon}
        </div>
    </Expire>
);




// WEBPACK FOOTER //
// ./src/sections/Message/MessageStatus.tsx